<template>
	<div>
		<slot>Set content as inline template.</slot>
	</div>
</template>

<script>
	export default {
		data () {
			return {
				show: false,
				closeSettingView: false,
				cookieSettingsOpen: false
			}
		},
		mounted() {
			this.show = !this.$cookies.isKey('site-cookie-consent');
			this.$root.$on('show-consent', () => {
				this.show = true;
			});
		},
		methods: {
			openCookieSettings() {
				this.cookieSettingsOpen = true;
			},
			hideCookieToolbar() {
				this.show = false;
				this.cookieSettingsOpen = false;
			},
			storeAllCookies() {
                this.$cookies.set('analytics-consent', true, 60 * 60 * 24 * 365);
                this.$cookies.set('site-cookie-consent', true, 60 * 60 * 24 * 365);
                this.$cookies.set('site-popup-consent', true, 60 * 60 * 24 * 365);
				this.cookieSettingsOpen = false;
                this.show = false;
			},
            storeNecessary() {
                this.$cookies.set('site-cookie-consent', true, 60 * 60 * 24 * 365);
                this.$cookies.set('analytics-consent', false, 60 * 60 * 24 * 365);
                this.$cookies.set('site-popup-consent', false, 60 * 60 * 24 * 365);
				this.cookieSettingsOpen = false;
				this.show = false;
            }
		}
	}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/CookieConsent.vue